import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'billing',
});

export const overviewRouteRef = createRouteRef({
  id: 'billing-overview',
});

export const spUsageRouteRef = createRouteRef({
  id: 'billing-sp-usage',
});

export const invoiceRouteRef = createRouteRef({
  id: 'billing-invoice',
});

export const invoiceListRouteRef = createRouteRef({
  id: 'billing-invoice-list',
});

export const invoiceCreateRouteRef = createRouteRef({
  id: 'billing-invoice-create',
});

export const invoiceEditRouteRef = createRouteRef({
  id: 'billing-invoice-edit',
});

export const termOfPaymentRouteRef = createRouteRef({
  id: 'billing-term-of-payment',
});

export const termOfPaymentCreateRouteRef = createRouteRef({
  id: 'billing-term-of-payment-create',
});

export const termOfPaymentEditRouteRef = createRouteRef({
  id: 'billing-term-of-payment-edit',
});
